import React from 'react';
import { Sidebar } from './Sidebar';
import gradientBg from '../assets/images/Gradient.avif';

interface LayoutProps {
	children: React.ReactNode;
	hideSidebar?: boolean;
}

export function Layout({ children, hideSidebar = false }: LayoutProps) {
	return (
		<div className="min-h-screen relative overflow-hidden">
			{/* Background image with opacity */}
			<div 
				className="fixed inset-0 pointer-events-none"
				style={{
					backgroundImage: `url(${gradientBg})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
					opacity: 0.15
				}}
			/>
			
			{/* Subtle grid pattern */}
			<div className="fixed inset-0 bg-[radial-gradient(circle_at_1px_1px,_rgba(0,0,0,0.05)_1px,_transparent_0)] bg-[length:32px_32px] pointer-events-none" />
			
			{!hideSidebar && <Sidebar />}
			<div className={hideSidebar ? 'relative' : 'ml-72 relative'}>
				<main className="flex-1">
					{children}
				</main>
			</div>
		</div>
	);
}
